import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import {
	CAPTURE_INTEGRATIONS_TASK,
	DEVOPS_CAPTURE_INTEGRATIONS_TASK,
} from '@atlassian/jira-onboarding-quickstart-core/src/common/constants.tsx';
import { QuickstartNudge } from '@atlassian/jira-onboarding-quickstart-core/src/common/ui/quickstart-nudge';
import type { QuickstartNudgeWrapperProps } from '@atlassian/jira-onboarding-quickstart-core/src/common/ui/quickstart-nudge/types';
import { NavigationItemContainer } from '../../common/ui/styled';
import { useCanShowQuickstartNudge } from '../../controllers/quickstart-nudge';
import messages from './messages';

export const NavigationAppsNavItemWrapperNudge = ({
	children,
	nudgeId,
	isInsideMenu,
}: QuickstartNudgeWrapperProps) => {
	const { formatMessage } = useIntl();
	const shouldShowNudge = useCanShowQuickstartNudge();

	if (!shouldShowNudge) {
		return <>{children}</>;
	}

	return (
		<QuickstartNudge
			nudgeId={nudgeId}
			itemNames={[CAPTURE_INTEGRATIONS_TASK, DEVOPS_CAPTURE_INTEGRATIONS_TASK]}
			// @ts-expect-error - TS2322 - Type 'StyledComponentClass<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { isHidden: boolean; }, any, ClassAttributes<...> & HTMLAttributes<...> & { ...; }>' is not assignable to type 'ComponentType<QuickstartNudgeContainerComponentProps> | undefined'.
			ContainerComponent={NavigationItemContainer}
			nudgeSpotlightCardProps={{
				content: formatMessage(messages.content),
				width: 320,
			}}
			isInsideMenu={isInsideMenu}
		>
			{children}
		</QuickstartNudge>
	);
};
